import { el } from "./dom.js";

export class DeathOverlay {
  readonly root: HTMLElement;
  private countdownEl: HTMLElement;
  private rafId = 0;
  private respawnAt = 0;

  constructor() {
    this.countdownEl = el("div", { class: "death-countdown" }, "5");
    this.root = el(
      "div",
      { class: "death-overlay hidden" },
      el("h2", { class: "death-title" }, "You died"),
      el("div", { class: "death-sub" }, "Respawning in"),
      this.countdownEl,
    );
  }

  show(respawnAt: number): void {
    this.respawnAt = respawnAt;
    this.root.classList.remove("hidden");
    if (this.rafId === 0) this.tick();
  }

  hide(): void {
    this.respawnAt = 0;
    this.root.classList.add("hidden");
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = 0;
    }
  }

  destroy(): void {
    this.hide();
    this.root.remove();
  }

  private tick = (): void => {
    if (this.respawnAt === 0) {
      this.rafId = 0;
      return;
    }
    this.rafId = requestAnimationFrame(this.tick);
    const remainingMs = Math.max(0, this.respawnAt - Date.now());
    const seconds = Math.ceil(remainingMs / 1000);
    this.countdownEl.textContent = String(seconds);
  };
}
